import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { motion } from "framer-motion";

export default function PolitiqueConfidentialite() {
  return (
    <div className="min-h-screen" data-testid="politique-confidentialite-page">
      <Header />
      <main>
        {/* Hero */}
        <section className="bg-gradient-to-br from-sky-500 to-blue-700 py-16 sm:py-20">
          <div className="max-w-7xl mx-auto px-6 sm:px-8 text-center">
            <motion.h1 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="font-['Outfit'] text-3xl sm:text-4xl font-bold text-white"
            >
              Politique de Confidentialité
            </motion.h1>
          </div>
        </section>

        {/* Content */}
        <section className="py-16">
          <div className="max-w-4xl mx-auto px-6 sm:px-8">
            <div className="prose prose-slate max-w-none space-y-8">
              
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 }}
              >
                <h2 className="font-['Outfit'] text-2xl font-bold text-blue-900 mb-4">
                  1. Introduction
                </h2>
                <p className="text-slate-700 leading-relaxed">
                  E@Tech s'engage à protéger la vie privée des utilisateurs de son site web. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations personnelles conformément au Règlement Général sur la Protection des Données (RGPD) et à la Loi Informatique et Libertés.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
              >
                <h2 className="font-['Outfit'] text-2xl font-bold text-blue-900 mb-4">
                  2. Responsable du traitement
                </h2>
                <p className="text-slate-700 leading-relaxed">
                  Le responsable du traitement des données est :<br />
                  <strong>E@Tech</strong>, située au 11 rue d'Amsterdam, 54500 VANDOEUVRE-LES-NANCY.<br />
                  Email : contact@eatech.fr
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 }}
              >
                <h2 className="font-['Outfit'] text-2xl font-bold text-blue-900 mb-4">
                  3. Données collectées
                </h2>
                <p className="text-slate-700 leading-relaxed">
                  Nous collectons les données suivantes :
                </p>
                <ul className="list-disc pl-6 mt-4 text-slate-700 space-y-2">
                  <li><strong>Via le formulaire de contact :</strong> Nom, prénom, adresse email, numéro de téléphone, nom de l'établissement (optionnel) et contenu du message.</li>
                  <li><strong>Via les outils de suivi (pixels) :</strong> Données de navigation, adresse IP, type de terminal et comportement sur le site.</li>
                </ul>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
              >
                <h2 className="font-['Outfit'] text-2xl font-bold text-blue-900 mb-4">
                  4. Finalités du traitement
                </h2>
                <p className="text-slate-700 leading-relaxed">
                  Vos données personnelles sont collectées pour les finalités suivantes :
                </p>
                <ul className="list-disc pl-6 mt-4 text-slate-700 space-y-2">
                  <li>Répondre à vos demandes de contact et de renseignements.</li>
                  <li>Fournir des devis personnalisés.</li>
                  <li>Assurer le suivi commercial.</li>
                  <li><strong>Publicité et analyse :</strong> Mesurer l'efficacité de nos campagnes publicitaires et vous proposer des contenus pertinents via les pixels publicitaires Google.</li>
                </ul>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5 }}
              >
                <h2 className="font-['Outfit'] text-2xl font-bold text-blue-900 mb-4">
                  5. Base légale du traitement
                </h2>
                <p className="text-slate-700 leading-relaxed">
                  Le traitement de vos données est fondé sur :
                </p>
                <ul className="list-disc pl-6 mt-4 text-slate-700 space-y-2">
                  <li>Votre consentement explicite lors de l'envoi du formulaire ou de l'acceptation des cookies.</li>
                  <li>Notre intérêt légitime à répondre à vos demandes et à améliorer nos services.</li>
                </ul>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6 }}
              >
                <h2 className="font-['Outfit'] text-2xl font-bold text-blue-900 mb-4">
                  6. Durée de conservation
                </h2>
                <p className="text-slate-700 leading-relaxed">
                  Vos données personnelles sont conservées pendant une durée de 3 ans à compter de votre dernier contact avec nous (ex: dernier email envoyé ou dernier clic sur un élément publicitaire), sauf obligation légale de conservation plus longue.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.7 }}
              >
                <h2 className="font-['Outfit'] text-2xl font-bold text-blue-900 mb-4">
                  7. Destinataires des données et Transferts hors UE
                </h2>
                <p className="text-slate-700 leading-relaxed">
                  Les données collectées sont destinées exclusivement aux services internes de E@Tech.
                </p>
                <p className="text-slate-700 leading-relaxed mt-4">
                  Toutefois, pour des raisons techniques, vos données font l'objet de transferts hors Union Européenne :
                </p>
                <ul className="list-disc pl-6 mt-4 text-slate-700 space-y-2">
                  <li><strong>Hébergement :</strong> Le site est hébergé par Emergent (États-Unis).</li>
                  <li><strong>Publicité :</strong> L'utilisation des pixels Google implique un transfert de données vers les serveurs de Google (États-Unis).</li>
                </ul>
                <p className="text-slate-700 leading-relaxed mt-4">
                  Ces transferts sont encadrés par des clauses contractuelles types afin de garantir un niveau de protection conforme au RGPD.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.8 }}
              >
                <h2 className="font-['Outfit'] text-2xl font-bold text-blue-900 mb-4">
                  8. Vos droits
                </h2>
                <p className="text-slate-700 leading-relaxed">
                  Conformément au RGPD, vous disposez des droits suivants :
                </p>
                <ul className="list-disc pl-6 mt-4 text-slate-700 space-y-2">
                  <li>Droit d'accès, de rectification et d'effacement de vos données.</li>
                  <li>Droit à la limitation et à l'opposition du traitement.</li>
                  <li>Droit à la portabilité de vos données.</li>
                </ul>
                <p className="text-slate-700 leading-relaxed mt-4">
                  Pour exercer ces droits, contactez-nous à : <a href="mailto:contact@eatech.fr" className="text-sky-600 hover:text-sky-700">contact@eatech.fr</a>.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.9 }}
              >
                <h2 className="font-['Outfit'] text-2xl font-bold text-blue-900 mb-4">
                  9. Sécurité des données
                </h2>
                <p className="text-slate-700 leading-relaxed">
                  Nous mettons en œuvre des mesures techniques (chiffrement, accès sécurisés) pour protéger vos données contre tout accès non autorisé ou toute divulgation.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.0 }}
              >
                <h2 className="font-['Outfit'] text-2xl font-bold text-blue-900 mb-4">
                  10. Cookies et Pixels publicitaires
                </h2>
                <p className="text-slate-700 leading-relaxed">
                  Notre site utilise des cookies et des pixels publicitaires Google. Ces outils permettent de comprendre votre navigation et d'afficher des publicités ciblées sur des sites tiers.
                </p>
                <p className="text-slate-700 leading-relaxed mt-4">
                  Vous pouvez vous opposer à ces cookies via le bandeau de consentement à l'entrée du site ou en configurant votre navigateur.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.1 }}
              >
                <h2 className="font-['Outfit'] text-2xl font-bold text-blue-900 mb-4">
                  11. Réclamation
                </h2>
                <p className="text-slate-700 leading-relaxed">
                  Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de la CNIL : <a href="https://www.cnil.fr" className="text-sky-600 hover:text-sky-700" target="_blank" rel="noopener noreferrer">www.cnil.fr</a>.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.2 }}
              >
                <h2 className="font-['Outfit'] text-2xl font-bold text-blue-900 mb-4">
                  12. Modification de la politique
                </h2>
                <p className="text-slate-700 leading-relaxed">
                  Nous nous réservons le droit de modifier cette politique. Les modifications prennent effet dès leur publication.
                </p>
                <p className="text-slate-500 mt-4 text-sm">
                  Dernière mise à jour : Avril 2026
                </p>
              </motion.div>

            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
